import { v4 as uuid } from 'uuid';

export const generateImageUrl = imageId =>
  `https://netlise-image-bucket.s3.ap-southeast-1.amazonaws.com/public/${imageId}`;

export const generateFileId = file => {
  const fileKey = uuid();
  let fileId;
  if (file) {
    fileId = `${fileKey}.${file.name.split('.').pop()}`;
    return fileId;
  }
  return null;
};

export const generateCloudImageUrl = imageId =>
  `https://salon-pos-bucket.s3.ap-southeast-1.amazonaws.com/public/${imageId}`;

// ── Upload validation (product images) ───────────────────────────────────────
// Masters are normalized server-side by the S3-trigger optimizer Lambda, but
// obviously-wrong files are rejected up front with a clear message.

const IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
const MAX_IMAGE_BYTES = 10 * 1024 * 1024; // 10 MB

/**
 * Validate a picked image file. Returns null when valid, otherwise a
 * human-readable error message.
 */
export const validateImageFile = file => {
  if (!file) return 'No file selected.';
  if (!IMAGE_TYPES.includes(file.type)) {
    return `"${file.name}" is not a supported image. Use JPG, PNG or WebP.`;
  }
  if (file.size > MAX_IMAGE_BYTES) {
    const mb = (file.size / (1024 * 1024)).toFixed(1);
    return `"${file.name}" is ${mb} MB — the limit is 10 MB. Please use a smaller image.`;
  }
  return null;
};
